import {
  TextField,
  Button,
  Typography,
  Box,
  MenuItem,
} from "@mui/material";
import { opcionesPorOperacion } from "../../configs/constants";


export default function ActivityCreate({
  empresaNombre,
  empresa,
  form,
  message,
  onChange,
  onReset,
  onClose,
  onSubmit,
  onOpenStock,
}) {
  const getLabel = () => {
    switch (form.operation) {
      case "Pagos":
        return "Tipo de pagos";
      case "Compras":
        return "Tipo de compras";
      case "Ingresos":
        return "Tipo de ingresos";
      default:
        return "Seleccione una operación";
    }
  };

  return (
    <Box component="form" onSubmit={onSubmit} noValidate >
      <Typography variant="h6" mb={1}>Crear nueva actividad</Typography>
      
      <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
        <TextField
          select
          label="Operación"
          fullWidth
          value={form.operation}
          onChange={onChange("operation")}
        >
          <MenuItem value="Pagos">Pagos</MenuItem>
          <MenuItem value="Compras">Compras</MenuItem>
          <MenuItem value="Ingresos">Ingresos</MenuItem>
        </TextField>

        {/* Botón visible solo si es Compras y la empresa tiene stock habilitado */}
        {form.operation === "Compras" && empresa?.stock && (
          <Button
            variant="outlined"
            size="small"
            onClick={onOpenStock}
          
          >
            Agregar a stock
          </Button>
        )}

      </Box>

      {form.operation ? (
        <TextField
          select
          label={getLabel()}
          fullWidth
          value={form.title}
          onChange={onChange("title")}
          sx={{ mb: 1 }}
          disabled={!form.operation}
        >
          {(
            opcionesPorOperacion[empresaNombre] ??
            opcionesPorOperacion["EmpresaPrueba"]
          )[0]?.[form.operation]?.map((op, index) => (
            <MenuItem key={index} value={op}>{op}</MenuItem>
          ))}
        </TextField>
      ) : (
        <Typography 
          color="gray"
          sx={{ mb: 10, mt: 6 }}
        >
          Seleccione una operación primero
        </Typography>
      )}

      {form.operation && (
        <TextField
          label="Descripción (opcional)"
          fullWidth
          multiline
          minRows={2}
          maxRows={2}
          value={form.description}
          onChange={onChange("description")}
          sx={{ mb: 1 }}
        />
      )}

      <TextField
        label="Monto"
        type="number"
        fullWidth
        value={form.amount}
        onChange={onChange("amount")}
        sx={{ mb: 1 }}
      />
      {message && (
        <Typography color="error" sx={{ mb: 1 }}>
          {message}
        </Typography>
      )}
      <Box sx={{ display: "flex", gap: 2 }}>
        <Button onClick={onReset} color="secondary">Restablecer</Button>
        <Button onClick={onClose}>Cerrar</Button>
        <Button type="submit" variant="contained" color="primary">Confirmar</Button>
      </Box>
    </Box>
  );
}